import { request } from '@mairistem/tools';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@mairistem/finances-utils';
import type { Exercice } from '@mairistem/comptabilite';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import { updateBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import BordereauEtat from '../../../constants/liquidation/bordereaux/BordereauEtat';
import Tdt from '../../../interfaces/common/Tdt';

class BordereauRelancerFluxAction extends BaseLiquidationAction<BordereauWithState, BordereauActionType> {
  constructor(options: BaseLiquidationOptions = null) {
    super(options);
    this.label = 'Relancer le flux';
    this.type = BordereauActionType.RELANCER_FLUX;
  }

  execute = (_bordereau: BordereauWithState): TreeviewActionResult<BordereauWithState> => ({
    type: ActionResultType.MODAL,
    extraProps: {
      isSuperUser: this.isSuperUser,
      relancerFluxBordereauModal: {
        visible: true,
      },
    },
  });

  executeAction = (bordereau: BordereauWithState, exercice: Exercice): TreeviewActionResult<BordereauWithState> => {
    const urlParam = new URLSearchParams();

    if (bordereau.identifiantExercice) {
      urlParam.append('identifiantExercice', bordereau.identifiantExercice.toString());
    }
    if (bordereau.identifiant) {
      urlParam.append('identifiantBordereau', bordereau.identifiant.toString());
    }
    if (bordereau.typePes) {
      urlParam.append('typeBordereau', bordereau.typePes);
    }
    if (bordereau.identifiantEntite) {
      urlParam.append('identifiantEntite', bordereau.identifiantEntite.toString());
    }

    const result = (async () => {
      const { url } = await request
        .get<unknown, { url: string }>(`/api/finances/comptabilite/pes/url?${urlParam.toString()}`)
        .catch((error) => {
          toast.error(getErrorMessage(error.message, 'Impossible de relancer le flux PES'));
          throw error;
        });

      window.open(url);

      return updateBordereau({
        ...bordereau,
        etat: exercice.entite.tdtIxchange2 === Tdt.IXCHANGE2 ? BordereauEtat.TRAITEMENT_PES_EN_INSTANCE : '',
        acquitte: 0,
        anomalieAck: '',
        motifEchec: '',
      }, new URLSearchParams({ isRelancerFlux: 'true', withJournaux: 'true' }))
        .catch((error) => {
          toast.error(getErrorMessage(error, 'Erreur lors de la modification du bordereau'));
          throw error;
        });
    })();

    return {
      result,
      type: ActionResultType.UPDATE,
    };
  };
}

export default BordereauRelancerFluxAction;
